import React from 'react';
import {NeuroMessage, AnswersList, useNeuroState} from '@ignitesales/neuro-application';
import Collapsible from "react-collapsible";
import ReactSVG from 'react-svg';
import { getBankSaved } from '../../utils/getBank.js';
import { getParams } from '../../utils/getParams.js';
import { renderProductAddOns, renderProductFeatures, renderProductDisclosures } from '../../utils/recPageFunctions.jsx';

function DetailsPage({ componentClass, productsList }) {
    const { answers } = useNeuroState();
    const bankFromUrl = getParams();
    const bankSelected = getBankSaved(bankFromUrl, answers.urlParameters);

    return (
        <div className={`${componentClass} ${bankSelected}`} id={componentClass}>
            <div className="mainContainer">
                <div className={`${componentClass}__header`}>
                    <div className='titleContainer'>
                        <h2 className='title'><NeuroMessage id="summary.portfolio" tagName="span" /> <span className='subtitle'><NeuroMessage id="summary.justForYou" tagName="span" /></span></h2>
                    </div>
                </div>
                <div className={`${componentClass}__products`}>
                  { productsList.map(p => 
                    <div className={`${componentClass}__product`}>
                      <div className="product-info">
                          <NeuroMessage id={p.id.toString() + ".name"} tagName="h1" />
                          <NeuroMessage id={p.id.toString() + ".description"} tagName="span" />
                      </div>
                      <div className="product-features">
                          {renderProductFeatures(p.id)}
                      </div>
                      <div className="product-disclosures">
                          {renderProductDisclosures(p.id)}
                      </div>
                      <div className="product-addOnProducts">
                          {renderProductAddOns(p)}
                      </div>
                    </div>)
                  }
                </div>
            </div>

            <div className={`${componentClass}__answers`}>
                <Collapsible trigger={<div className='answersListHeader'><NeuroMessage id="summary.yourAnswers" tagName="span" /><i class="fa fa-chevron-right"/></div>}>
                    <AnswersList linkToQuestion />
                </Collapsible>
            </div>

            <div className={`${componentClass}__footerCopyright`}>
                <NeuroMessage id="copyright" tagName="span" />
                <ReactSVG src={'/classpath/assets/images/fdic-logo.svg'}/>
            </div>
        </div>
    );
}

export default DetailsPage;

